module.exports = __webpack_public_path__ + "img/汉熵多模异构物联网管理平台.dcb3d670.png";